import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  dueDetailsAndDueDetailsBreakupReportsList: { loading: false, data: null, error: null },
};

export const DueDetailsAndDueDetailsBreakupReportSlice = createSlice({
  name: "dueDetailsAndDueDetailsBreakupReport",
  initialState,
  reducers: {
    fetchDueDetailsAndDueDetailsBreakupReportsListRequest: (state, action) => {
      state.dueDetailsAndDueDetailsBreakupReportsList.loading = true;
      state.dueDetailsAndDueDetailsBreakupReportsList.error = null;
    },
    fetchDueDetailsAndDueDetailsBreakupReportsListSuccess: (state, action) => {
      state.dueDetailsAndDueDetailsBreakupReportsList.data = action.payload;
      state.dueDetailsAndDueDetailsBreakupReportsList.loading = false;
      state.dueDetailsAndDueDetailsBreakupReportsList.error = null;
    },
    fetchDueDetailsAndDueDetailsBreakupReportsListFailure: (state, action) => {
      state.dueDetailsAndDueDetailsBreakupReportsList.data = null;
      state.dueDetailsAndDueDetailsBreakupReportsList.loading = false;
      state.dueDetailsAndDueDetailsBreakupReportsList.error = action.payload;
    },
  },
});

export const {
  fetchDueDetailsAndDueDetailsBreakupReportsListRequest,
  fetchDueDetailsAndDueDetailsBreakupReportsListSuccess,
  fetchDueDetailsAndDueDetailsBreakupReportsListFailure,
} = DueDetailsAndDueDetailsBreakupReportSlice.actions;

export const getDueDetailsAndDueDetailsBreakupReportsListState = (store) =>
  store.dueDetailsAndDueDetailsBreakupReport?.dueDetailsAndDueDetailsBreakupReportsList;

export default DueDetailsAndDueDetailsBreakupReportSlice.reducer;
